import React, { useEffect, useState, useContext, use } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import { ConfigContext } from "../context/GlobalContext";
import PremiumCard from "../components/PremiumCard";
import { LogoutUser } from "../data/Firebase/Authentication";
import { Languages } from "../Utils/Languages";
import * as actionType from '../context/actions';
import { useNavigate } from "react-router-dom";
import DeleteAccountView from "../components/DeleteAccountView";
import GuestLoginSuggestionModal from "../components/GuestLoginSuggestionModal";
import { PremiumFeatureOnlyModal } from "../components/PremiumFeatureOnlyModal";
import { Tooltip } from 'bootstrap/dist/js/bootstrap.bundle.min.js';


const MasterLayout = ({ children }) => {

  let [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation();
  const { state, dispatch } = useContext(ConfigContext);
  const Email = state?.USERID ? state?.SET_USER?.email : "";
  const name = state?.USERID ? state?.SET_USER?.name : "";
  const contact = state?.USERID ? state?.SET_USER?.contact : "";
  const ProfileImage = state?.USERID ? state?.SET_USER?.userPhoto || null : null;
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showModel, setshowModal] = useState(false);
  const [isDisplayPrimiumFeatureModel, setIsDisplayPrimiumFeatureModel] = useState(false);

  const latestPayment = [...(state?.PAYMENT || [])]
    .sort((a, b) => {
      const dateA = Number(a?.lastDate?.length > 10 ? a?.lastDate : a?.lastDate * 1000 || 0);
      const dateB = Number(b?.lastDate?.length > 10 ? b?.lastDate : b?.lastDate * 1000 || 0);
      return dateB - dateA;
    })[0];

  const languageList = [
    { code: "en", label: "English" },
    { code: "hi", label: "हिंदी" },
    { code: "gu", label: "ગુજરાતી" },
    { code: "fr", label: "Français" },
    { code: "de", label: "Deutsch" },
    { code: "nl", label: "Nederlands" },
    { code: "es", label: "Español" },
    { code: "it", label: "italiano" },
    { code: "ja", label: "日本" },
    { code: "ch", label: "中文" },
    { code: "ko", label: "한국어" },
    { code: "ms", label: "Melayu" },
    { code: "ta", label: "தமிழ்" },
    { code: "te", label: "తెలుగు" },
  ];

  const navigate = useNavigate();

  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px"; // Collapse submenu
        }
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
        }
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
            }
          }
        });
      });
    };

    // Open the submenu that contains the active route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  const handleDeleteAccount = () => {
    setShowDeleteModal(true);
    const mailtoLink = `mailto:support@billnama.com?subject=Account deletion request for user%0D%0A${state?.USERID}&body=Hello,%0D%0A%0D%0A%0D%0APlease delete my account from BillNama having following details%0D%0A%0D%0AUserId: ${state?.USERID}%0D%0AEmail: ${Email}%0D%0AReason: <Write Here your Reason>%0D%0A%0D%0A%0D%0ABest%0D%0A%0D%0A%0D%0ASent from Website`;
    window.location.href = mailtoLink
  }

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  useEffect(() => {
    // Select all elements with data-bs-toggle="DefaultTooltipThree"
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="DefaultTooltipThree"]');
    // Initialize tooltips
    const tooltipList = Array.from(tooltipTriggerList).map(
      (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl)
    );
    // Cleanup on unmount
    return () => {
      tooltipList.forEach((tooltip) => tooltip.dispose());
    };
  }, []);

  const isPremium = state?.PREMIUM;

  return (
    <section className={`overlay ${mobileMenu ? "active no-scroll-page" : ""}`}>
      {/* sidebar */}
      <aside
        className={
          mobileMenu
            ? "sidebar sidebar-open"
            : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type="button"
          className="sidebar-close-btn"
        >
          <Icon icon="radix-icons:cross-2" />
        </button>
        <div>
          <Link to="/" className="sidebar-logo">
            <img
              src="assets/images/Billnama_logo.png"
              alt="site logo"
              className="light-logo"
            />
            <img
              src="assets/images/Billnama_logo-w.png"
              alt="site logo"
              className="dark-logo"
            />
            <img
              src="assets/images/Billnama_logo_icon.png"
              alt="site logo"
              className="logo-icon"
            />
          </Link>
        </div>
        <div className="sidebar-menu-area">
          <ul className="sidebar-menu" id="sidebar-menu">
            <li>
              <NavLink
                to="/dashboard"
                className={`${location.pathname.includes("dashboard") ? "active-page" : ""}`}
              >
                <Icon
                  icon="solar:home-smile-angle-outline"
                  className="menu-icon"
                />
                {Languages[state?.LANGUAGE]?.dashboard}
              </NavLink>
            </li>

            <li className="">
              <NavLink
                to="/business-list"
                className={`${location.pathname.includes("business") ? "active-page" : ""}`}
              >
                <Icon icon="tabler:building-store" className="menu-icon" />
                {Languages[state?.LANGUAGE]?.business}
              </NavLink>
            </li>

            <li className="">
              <NavLink
                to="/invoice-list"
                className={`${location.pathname.includes("invoice") ? "active-page" : ""}`}
              >
                <Icon icon="hugeicons:invoice-03" className="menu-icon" />
                {Languages[state?.LANGUAGE]?.invoice}
              </NavLink>
            </li>

            <li className="">
              <NavLink
                to="/proformainvoic"
                className={`${location.pathname.includes("proformainvoic") ? "active-page" : ""}`}
              >
                <Icon icon="heroicons-outline:receipt-tax" className="menu-icon" />
                Proforma Invoice
              </NavLink>
            </li>
            <li className="">
              <NavLink
                to="/quotation"
                className={`${location.pathname.includes("quotation") ? "active-page" : ""}`}
              >
                <Icon icon="mdi:receipt-text-outline" className="menu-icon" />
                Quotation
              </NavLink>
            </li>

            <li className="">
              <NavLink
                onClick={() => {
                  const hasSharedBusiness = state?.BUSINESSES?.some(b => b.isShared === true);
                  if (!isPremium && !hasSharedBusiness) {
                    setIsDisplayPrimiumFeatureModel(true);
                  }
                }}
                to={(isPremium || state?.BUSINESSES?.some(b => b.isShared === true)) ? "/sales-return" : "#"}
                className={(navData) =>
                  navData.isActive && (isPremium || state?.BUSINESSES?.some(b => b.isShared === true)) ? "active-page " : ""
                }
              >
                <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                  <Icon icon="lsicon:sales-return-outline" className="menu-icon" />
                  <span>{Languages[state?.LANGUAGE]?.sale_return}</span>
                  {!isPremium && !state?.BUSINESSES?.some(b => b.isShared === true) && (<i
                    className="fas fa-crown"
                    style={{
                      fontSize: "15px",
                      color: "gold",
                      marginLeft: "auto",
                    }}
                  ></i>)}
                </div>
              </NavLink>
            </li>
            <li className="">
              <NavLink
                to="/expense"
                className={`${location.pathname.includes("expense") ? "active-page" : ""}`}
              >
                <Icon icon="mdi:bank-minus" className="menu-icon" />
                {Languages[state?.LANGUAGE]?.expense}
              </NavLink>
            </li>

            <li className="">
              <NavLink
                to="/customer-list"
                className={`${location.pathname.includes("customer") ? "active-page" : ""}`}
              >
                <Icon icon="heroicons-outline:users" className="menu-icon" />
                {Languages[state?.LANGUAGE]?.customers}
              </NavLink>
            </li>

            <li className="">
              <NavLink
                to="/sold-items-list"
                className={`${location.pathname.includes("sold-items") ? "active-page" : ""}`}
              >
                <Icon icon="mdi:cart-check" className="menu-icon" />
                {Languages[state?.LANGUAGE]?.sold_items}
              </NavLink>
            </li>


            {/* <li className="">
              <NavLink
                to="/currency"
                className={(navData) =>
                  navData.isActive ? "active-page " : ""
                }
              >
                <Icon icon="mdi:cash-multiple" className="menu-icon" />
                {Languages[state?.LANGUAGE]?.currency}
              </NavLink>
            </li> */}

            {state?.TAXTYPE === "GST" && (
              <li className='dropdown'>
                <Link
                  to='#'
                  className={`${location.pathname.includes("gstr") ? "active-page" : ""}`}
                >
                  <Icon icon="mdi:chart-box-outline" className="menu-icon" />
                  <span>GST Reports</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink
                      to='/gstr-1'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                      GSTR-1
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to='/gstr-3b'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                      GSTR-3B
                    </NavLink>
                  </li>
                  {/* <li>
                  <NavLink
                    to='/gstr-2a'
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                    GSTR-2A
                  </NavLink>
                </li> */}
                </ul>
              </li>
            )}
            <PremiumCard />

          </ul>
        </div>
      </aside>

      <main
        className={"dashboard-main"}
      >
        <div className="navbar-header">
          <div className="row align-items-center justify-content-between">
            <div className=" col-auto d-flex gap-2" >
              <button
                onClick={mobileMenuControl}
                type="button"
                className="sidebar-mobile-toggle"
              >
                <Icon icon="heroicons:bars-3-solid" className="icon" />
              </button>
              <div className="d-flex flex-wrap align-items-center gap-3">
                {state.USERID ? (<button
                  className="w-40-px h-40-px rounded-circle d-flex justify-content-center align-items-center"
                  type="button"
                  style={{ backgroundColor: "var(--brand)", color: "white" }}
                  onClick={() => navigate("/user_details")}
                  data-bs-toggle="DefaultTooltipThree"
                  data-bs-placement="top"
                  data-bs-custom-class="tooltip-primary"
                  data-bs-title="User Details"
                >

                  {name?.charAt(0)?.toUpperCase() ||
                    Email?.charAt(0)?.toUpperCase() ||
                    contact?.charAt(0)?.toUpperCase()}
                </button>) : ""}

                <p style={{ margin: "0px", color: "var(--text-secondary-light)", fontFamily: 'sans-serif', fontWeight: 500, fontSize: 18 }}>
                  {name || contact || Email || "Unknown"}
                </p>

              </div>
            </div>

            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-3">
                <span
                  data-bs-toggle="DefaultTooltipThree"
                  data-bs-placement="top"
                  data-bs-custom-class="tooltip-primary"
                  data-bs-title="Appearance"
                >
                  <ThemeToggleButton />
                </span>
                {state?.PREMIUM && latestPayment?.planName === process.env.REACT_APP_AGENCY_PLAN_NAME && (
                  <div className="dropdown mt-1">
                    <Link
                      to="/members"
                      data-bs-toggle="DefaultTooltipThree"
                      data-bs-placement="top"
                      data-bs-custom-class="tooltip-primary"
                      data-bs-title="Agency Members"
                    >
                      <button
                        className="w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
                        type="button"
                      >
                        <Icon
                          icon="mdi:account-group-outline"
                          width={22}
                          height={22}
                        />
                      </button>
                    </Link>
                  </div>
                )}
                {state?.USERID ? (
                  <>
                    {/* <div className=""> */}
                    {/* <button
                        className="w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
                        type="button"
                        data-bs-toggle="dropdown"
                      >
                        <Icon
                          icon="mdi:translate"
                          className="object-fit-cover rounded-circle"
                        />
                      </button>
                      <div className="dropdown-menu to-top dropdown-menu-sm">
                        <ul className="to-top-list">
                          {languageList.map((lang) => (
                            <li key={lang.code}>
                              <Link
                                className={`dropdown-item px-0 py-8 d-flex align-items-center gap-3 ${state?.LANGUAGE === lang.code
                                  ? "text-white fw-bold rounded border"
                                  : "text-black hover-text-primary"
                                  } ps-3 `}
                                style={{
                                  backgroundColor: state?.LANGUAGE === lang.code ? "#487fff" : "transparent",
                                }}
                                onClick={() =>
                                  dispatch({ type: actionType.LANGUAGE, payload: lang.code })
                                }
                              >
                                {lang.label}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div> */}
                    {/* </div> */}
                    <div className="dropdown mt-1">
                      <Link
                        to="/referral"
                        data-bs-toggle="DefaultTooltipThree"
                        data-bs-placement="top"
                        data-bs-custom-class="tooltip-primary"
                        data-bs-title="Referral"
                      >
                        <button
                          className="w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
                          type="button"
                        >
                          <Icon
                            icon="mdi:gift-outline" // 🎁 Gift icon
                            className="object-fit-cover rounded-circle"
                            width={22}
                            height={22}
                          />
                        </button>
                      </Link>
                    </div>


                    <div
                      className="dropdown mt-1"
                      data-bs-toggle="DefaultTooltipThree"
                      data-bs-placement="top"
                      data-bs-custom-class="tooltip-primary"
                      data-bs-title="Settings"
                    >
                      <button
                        className="w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
                        type="button"
                        data-bs-toggle="dropdown"
                      >
                        <Icon
                          icon="icon-park-outline:setting-two"
                          className="object-fit-cover rounded-circle"
                        />
                      </button>
                      <div className="dropdown-menu to-top dropdown-menu-sm">
                        <ul className="to-top-list">
                          <li>
                            <Link
                              className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                              to="/sessions"
                            >
                              <Icon icon="mdi:clock-time-five-outline" className="icon text-xl" />
                              {Languages[state?.LANGUAGE]?.Session}
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                              to="/payment"
                            >
                              <Icon icon="mdi:credit-card-outline" className="icon text-xl" />
                              {Languages[state?.LANGUAGE]?.billing}
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                              onClick={handleDeleteAccount}
                            >
                              <Icon icon="mdi:account-remove" className="icon text-xl text-danger" />
                              {Languages[state?.LANGUAGE]?.Delete_My_Account}
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                              to="/login"
                              onClick={() => LogoutUser(dispatch)}
                            >
                              <Icon icon="lucide:power" className="icon text-xl" />
                              {Languages[state?.LANGUAGE]?.Log_Out}
                            </Link>
                          </li>
                        </ul>

                        {/* Subtle version info */}
                        <div className="text-black text-xs text-center pt-2 pb-1 mt-2">
                          Version {process.env.REACT_APP_VERSION}
                        </div>
                      </div>
                    </div>

                  </>) : (
                  <Link
                    to="/login"
                  // className="bg-primary-600 text-white font-semibold py-2 px-4 rounded-lg shadow-md hover:bg-primary-700 transition duration-300 ease-in-out transform hover:scale-105"
                  >
                    <button
                      type="reset"
                      className="border btn-sm border-primary-600 bg-hover-primary-200 text-primary-600 text-md px-40 py-6 radius-8"
                    >
                      {Languages[state?.LANGUAGE]?.Log_In || "Login"}
                    </button>
                  </Link>
                )}
                {/* Profile dropdown end */}

                {showDeleteModal && (
                  <DeleteAccountView
                    show={showDeleteModal}
                    setShow={setShowDeleteModal}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className="dashboard-main-body">
          {children}
          <PremiumFeatureOnlyModal
            isOpen={isDisplayPrimiumFeatureModel}
            onClose={() => setIsDisplayPrimiumFeatureModel(false)}
            featureName="Sales-Return"
          />
        </div>

        {/* Footer section */}
        <footer className="d-footer">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <p className="mb-0">
                © {new Date().getFullYear()}{" "}
                <Link to="https://billnama.com/" style={{ color: "#4c5fdf" }}>
                  billnama.com
                </Link>
                . All Rights Reserved.
              </p>
            </div>
          </div>
        </footer>

        <GuestLoginSuggestionModal />
      </main>
    </section>
  );
};

export default MasterLayout;
